import React from 'react';
import { useTranslation } from 'react-i18next';
import { LANGUAGE_STORAGE_KEY, SUPPORTED_LANGS } from '../../i18n/config';
import { cn } from '../../utils/cn';

// One button per supported language, so a locale added to `SUPPORTED_LANGS` is offered
// here as soon as detection can pick it. The label is the code itself.
const LANGUAGES = SUPPORTED_LANGS.map((code) => ({ code, label: code.toUpperCase() }));

const LanguageToggle = () => {
  const { t, i18n } = useTranslation();

  const handleChange = (code) => {
    i18n.changeLanguage(code);
    try {
      localStorage.setItem(LANGUAGE_STORAGE_KEY, code);
    } catch {
      // localStorage unavailable — language still switches for this session
    }
  };

  return (
    <div role="group" aria-label={t('language')} className="flex items-center bg-muted rounded-full p-0.5 shrink-0">
      {LANGUAGES.map(({ code, label }) => (
        <button
          key={code}
          type="button"
          onClick={() => handleChange(code)}
          aria-pressed={i18n.language === code}
          className={cn(
            'px-2.5 py-1 text-xs font-medium rounded-full transition-colors',
            i18n.language === code
              ? 'bg-foreground text-background'
              : 'text-foreground hover:bg-muted-foreground/10'
          )}
        >
          {label}
        </button>
      ))}
    </div>
  );
};

export default LanguageToggle;
